import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { studioApi } from './studioApi';

const Ctx = createContext({ project: null, options: null, reload: async () => {}, variantsByPhoto: {}, running: null });

export function ProjectProvider({ children }) {
  const [project, setProject] = useState(null);
  const [options, setOptions] = useState(null);

  const reload = useCallback(async () => {
    const { data } = await studioApi.get('/project');
    setProject(data);
    return data;
  }, []);

  const patchPhoto = useCallback((doc) => setProject((p) => (p ? { ...p, photos: p.photos.map((x) => (x.id === doc.id ? { ...x, ...doc } : x)) } : p)), []);
  const addPhoto = useCallback((doc) => setProject((p) => (p && !p.photos.some((x) => x.id === doc.id) ? { ...p, photos: [...p.photos, doc] } : p)), []);

  useEffect(() => {
    reload().catch(() => {});
    studioApi.get('/options').then((r) => setOptions(r.data)).catch(() => {});
  }, [reload]);

  const running = project?.simulations.find((s) => s.status === 'queued' || s.status === 'processing') || null;
  const detecting = project?.photos.some((p) => p.windows_status === 'detecting');
  useEffect(() => {
    if (!running && !detecting) return undefined;
    const id = setInterval(() => reload().catch(() => {}), 3500);
    return () => clearInterval(id);
  }, [running, detecting, reload]);

  const variantsByPhoto = useMemo(() => {
    const out = {};
    (project?.simulations || []).forEach((job) => job.items.forEach((it) => {
      if (it.status !== 'done' || !it.file_id) return;
      (out[it.photo_id] ||= []).push({ ...it, job_id: job.id, window_style: job.window_style, grille: job.grille, created_at: job.created_at });
    }));
    return out;
  }, [project]);

  return <Ctx.Provider value={{ project, options, reload, patchPhoto, addPhoto, variantsByPhoto, running }}>{children}</Ctx.Provider>;
}

export const useProject = () => useContext(Ctx);

// Próximo passo sugerido pelo estado do projeto
export const nextStep = (p) => {
  if (!p || !p.photos.length) return 'photos';
  if (!p.simulations.length) return 'design';
  return 'reveal';
};
